export enum DeliveryType {
  Unknown = 0,
  Delivery = 1,
  PickUp = 2,
  Digital = 3,
}
